'use strict';

const notImplementedError = Error('Not implemented');

export default class iContentBlockService {
  getAllContentBlocks() {
    throw new notImplementedError;
  }
  getContentBlockById() {
    throw new notImplementedError;
  }
  addContentBlock() {
    throw new notImplementedError;
  }
  updateContentBlock() {
    throw new notImplementedError;
  }
}
